import React from "react";
import ProductCard from "../../../../../Reusable/Product Card/ProductCard";

// -----------------------------importing Data-----------------
import { SkarduHotelsData } from "./Skardu Hotels Mapping Data";

// -------------------mapping() function------------------------

function SkarduHotelsProductCard() {
  return (
    <>
      {SkarduHotelsData.map((product) => {
        return (
          <ProductCard
            key={product.id}
            img={product.img}
            date={product.date}
            month={product.month}
            price={product.price}
            detail={product.detail}
            path={product.path}
          />
        );
      })}
    </>
  );
}

export default SkarduHotelsProductCard;
